import { type FC, useEffect, useState } from "react";
import {
    Button,
    ButtonColour,
    ButtonStyle,
    Icon,
} from "@onshopfront/components";
import { useShopfrontDispatch } from "../_Bootstrap/hooks";
import { hideMissingPermissions } from "../Actions/CustomerDisplay/CustomerDisplayActions";
import PopupManager from "../Common/Popups/PopupManager";
import { ZendeskArticle } from "../Common/Zendesk/ZendeskArticle";

export const MissingPopupPermissionError: FC = () => {
    const dispatch = useShopfrontDispatch();

    const [ query, setQuery ] = useState<PermissionStatus | null>(null);

    useEffect(() => {
        navigator.permissions.query({ name: "window-management" as any })
            .then(setQuery)
            .catch(err => {
                console.error("Error trying to load window management permission query", err);
                dispatch(hideMissingPermissions());
            });
    }, [ dispatch ]);

    useEffect(() => {
        if(!query) {
            return;
        }

        if(query.state === "granted") {
            dispatch(hideMissingPermissions());

            return;
        }

        const listener = () => {
            if(query.state === "granted") {
                dispatch(hideMissingPermissions());
                PopupManager.success(
                    "The missing permissions have been granted. Please attempt to re-open the customer display"
                );
            }
        };

        query.addEventListener("change", listener);

        return () => {
            query.removeEventListener("change", listener);
        };
    }, [ dispatch, query ]);

    useEffect(() => {
        PopupManager.warning(
            "Please enable Window Management to allow Shopfront to open the customer display.",
            false,
            false,
            10_000 // 10 seconds (Double the normal amount)
        );
    }, []);

    return (
        <div className="absolute z-2 inset-0 flex items-center justify-center bg-black/70">
            <div className="bg-white dark:bg-dark-900">
                <div className="px-8 py-4">
                    <Button
                        style={ButtonStyle.Filled}
                        colour={ButtonColour.Neutral}
                        onClick={() => {
                            dispatch(hideMissingPermissions());
                        }}
                    >
                        <Icon
                            icon={[ "fal", "times" ]}
                            className="mr-2"
                        />
                        Close
                    </Button>
                </div>
                <div className="max-w-xl w-[90vw] max-h-[550px] h-viewport overflow-auto">
                    <ZendeskArticle
                        id="115003865372"
                        scrollAnchor="h_01J0WRSY0NWYK8NWGXBWQNR5V9"
                    />
                </div>
            </div>
        </div>
    );
};
